export default __webpack_public_path__ + "static/article-do-we-need-to-learn-how-to-travel-again-1670b5d52930aaf3fab985283610b8e4.jpg";